import './style.scss';
import loadImage from '../../../styles/assets/images/sv/loader.svg';

const Spinner = ({size = 32}) => {
    return (
        <div className="spinner">
            <img src={loadImage} style={{ width: size, height: size }}/>
        </div>
    )
}

export default Spinner;